import React from 'react';

import './chip-filter-image.scss';

import { IClassNames, makeClassNames } from '../../../utils/styles';
import TypographyElements from '../../foundation/typography/typography-element/typography-elements';

export interface IChipFilterImage {
  text: string;
  itemId: number;
  isSelected: boolean;
  isDesktop: boolean;
  selectChip: (value: number) => void;
  images: {
    chip?: {
      alt?: string;
      desktop?: string;
      mobile?: string;
    };
  };
}
const ChipFilterImage: React.FC<IChipFilterImage> = ({
  selectChip,
  text,
  isSelected = false,
  isDesktop = false,
  itemId,
  images,
}) => {
  const classNames = (isDesktop: boolean, isSelected: boolean): IClassNames =>
    makeClassNames({
      chipSubsection: [
        'chip-subsection',
        isDesktop && 'chip-subsection__desktop',
        isSelected && 'chip-subsection--selected',
      ],
      chipSubsectionImage: ['chip-subsection__image', isDesktop && 'chip-subsection__image__desktop'],
      chipSubsectionText: ['chip-subsection__text'],
      chipSubsectionWrapper: [
        'chip-subsection__wrapper',
        isSelected && isDesktop && 'chip-subsection__wrapper__desktop--selected',
      ],
    });
  const cn = classNames(isDesktop, isSelected);

  return (
    <button aria-label={text} type="button" className={cn.chipSubsection} onClick={() => selectChip(itemId)}>
      <div className={cn.chipSubsectionWrapper}>
        <img className={cn.chipSubsectionImage} src={images.chip![isDesktop ? 'desktop' : 'mobile']} />
        <span className={cn.chipSubsectionText}>
          <TypographyElements text={text.toUpperCase()} typographyClass="ty-elements-small" />
        </span>
      </div>
    </button>
  );
};
export default ChipFilterImage;
